<template>
  <div id="coach_certification_outer" :class="[ isVip ? 'shba-vips-border-color' : 'shba-no-vips-border-color']">
    <div style="position: relative;margin-top: 30px;">
      <el-steps id="coach_cert_top_steps" :active="stepIndex" finish-status="success" align-center>
        <el-step v-for="(item, index) in stepList" :key="'step_item_' + index" :title="item" />
      </el-steps>
    </div>

    <div style="margin-top: 30px; min-height: 150px;padding-bottom: 30px;position: relative;">
      <ready-vue v-if="stepIndex == 0" :coachItem="coachData" />
      <verify-vue v-else-if="stepIndex == 1"
                  :name="coachData.coach.name"
                  :idNo="coachData.coach.idNo"
                  v-on:realNameVerifySuccess="userVerifySuccess"
                  v-on:backToEditPage="resubmitButtonClicked"
				  v-on:next-step="vnNextStepClicked"
                  v-bind:next-button-text="'下一步'"
      />
      <check-view v-else-if="stepIndex == 2"
        :coachItem="coachData"
        v-on:delete="deleteCurrentCoach"
        v-on:baktoPreview="resubmitButtonClicked" />

      <success-view v-if="successed" :coachItem="coachData" />

    </div>

  </div>
</template>

<script>
  import CoachCertReady from "./CoachCertReady.vue";
  import IdentificationVerificationVue from "../../common/IdentificationVerificationVue.vue";
  import CoachOfficialCheck from "./CoachOfficialCheck.vue";
  import CoachSuccessView from "./CoachSuccess.vue";
  import EventManager from "../../../js/event-common.js";
  import {Loading} from "element-ui";
  export default {
    name: 'coachCertificationVue',
    data () {
      return {
        stepList: [
          '填写认证信息',
          '实名认证',
          '协会审核'
        ],
        flag: 'coach-certification-flag',
        stepIndex: 0,
        successed: false,
        coachData: null,
        coachList: null,
        initialSucceed: false,
        timflag: null,
      }
    },
    components: {
      ReadyVue: CoachCertReady,
      VerifyVue: IdentificationVerificationVue,
      CheckView: CoachOfficialCheck,
      SuccessView: CoachSuccessView,
    },
    computed: {
      eventManager() {
        return this.$store.state.eventManager;
      },
      httpManager() {
        return this.$store.state.http;
      },
      certId() {
        return this.$route.params.certId;
      },
      user() {
        return this.$store.state.user;
      },
      isVip() {
        if (this.user == null) {
          return false;
        }
        let user = this.user;
        let memberValidDate = user.memberValidDate;
        if (memberValidDate == null) {
          return false;
        }
        return this.$moment(memberValidDate).add('1','days').add('-1', 'seconds').isAfter(this.$moment());
      },
    },
    destroyed() {
      this.eventManager.unregisterAllEvents(this.flag);
      this.removeUpdateDataTimer();
    },
    mounted() {
      let certId = this.certId;
      this.loadData();

      let _this = this;
      this.eventManager.register(this.flag, EventManager.notificationNameObject.updateCoachData, function (data) {
        _this.loadData();
      });
    },
    methods: {
      updateStatus(status, success, failure) {
        let params = {};
        let coachItem = this.coachData;
        if (coachItem == null) {
          return;
        }
        params.status = status;
        params.auditStatus = coachItem.coach.auditStatus;
        params.id = coachItem.coach.id;
        this.httpManager.ajax.postCoachStatusUpdateRequest(params, function(data) {
          console.log(data);
          console.log('upate coach status succeed!');
          let code = data.code;
          if (code == 0) {
            success();
            return;
          }
          failure(data);
        }, function(data) {
          failure(data);
        });
      },

	  vnNextStepClicked() {
		  let _this = this;
		  this.updateStatus(6, function() {
		    _this.loadData();
		  }, function(data) {
		    console.log('update status failed!');
		    _this.$toast("提交失败！");
		  });
	  },
      userVerifySuccess() {

      },
      resubmitButtonClicked() {
        this.stepIndex = 0;
        this.coachData.coach.status = 0;
      },
      deleteCurrentCoach() {
        let coach = this.coachData.coach;
        if (coach == null) {
          return;
        }
        let id = coach.id;
        let params = {
          id
        };
        let loadingFlag = Loading.service({
          target: document.getElementById('app'),
          fullscreen: true
        });
        let _this = this;
        this.httpManager.ajax.postCoachDeleteRequest(params, function(data){
          console.log(data);
          loadingFlag.close();
          let code = data.code;
          if (code == 0) { // 删除成功
            _this.$toast("取消成功!");
            setTimeout(function() {
              _this.eventManager.postNotification(EventManager.notificationNameObject.coachApplicationSuccess, null);
              _this.$router.push({
                name: 'personalHomeVue'
              });
            }, 1000);
            return;
          }
          _this.$toast("操作失败！");
        }, function(data) {
          loadingFlag.close();
          _this.$toast("操作失败，请重试");
        });
      },
      loadData() {
        let user = this.user;
        if (user == null) {
          let _this = this;
          setTimeout(function() {
            _this.loadData();
          }, 500);
          return;
        }

        let params = {
          userId: user.id
        };

        let _this = this;
        this.httpManager.ajax.getUserCoachListData(params, function(data) {
          console.log(data);
          let code = data.code;
          if (code == 0) {
            let coachList = data.data;
            if (coachList == null) {
              coachList = [];
            }
            _this.coachList = coachList;
            _this.$store.commit("setCoachData", coachList);
            _this.initialSucceed = true;
            _this.dealWithCoachData();
            _this.updateRoute();
            return;
          }
          console.log(data);
        }, function(data) {
          console.log('请求失败');
          console.log(data);
        });
      },

      updateRoute() {
        let coachData = this.coachData;
        if (coachData == null) {
          return;
        }
        let coach = coachData.coach;
        if (coach == null) {
          return;
        }
        let id = coach.id;
        if (this.certId != id) {
          this.$router.push({
            name: this.$route.name,
            params: {
              certId: id,
            }
          });
        }
      },

      addUpdateDataTimer() {
        let _this = this;
        this.timflag = setTimeout(function() {
          console.log('upate');
          _this.timflag = null;
          _this.loadData();
        }, 15 * 1000);
      },

      removeUpdateDataTimer() {
        if (this.timflag != null) {
          clearTimeout(this.timflag);
          this.timflag = null;
        }
      },

      dealWithCoachData() {
        let coachList = this.coachList;
        if (coachList.length == 0) {
          this.coachData = {
            coach: null
          }
          return;
        }

        if (coachList.length == 1) {
          this.coachData = coachList[0];
        } else {

          let completedItem = null;
          let incompletedItem = null;
          for (let i = 0; i < coachList.length; i++) {
            let item = coachList[i];
            let coach = item.coach;
            if (coach.status == 7) {
              completedItem = item;
            } else {
              incompletedItem = item;
            }
          }

          //将旧的coach数据 copy到新的coach数据中
          if (completedItem != null && incompletedItem != null) {
            if (incompletedItem.certificates == null || incompletedItem.certificates.length == 0) {
              console.log('certificates没数据!');
              console.log(incompletedItem.certificates.length);
              let certificates = [];

              for (let i = 0; i < completedItem.certificates.length; i++) {
                let item = completedItem.certificates[i];
                let newObj = {};
                for(let key in item) {
                  if (key == 'id') {
                    newObj[key] = 0;
                  } else if (key == 'coachId') {
                    
                    newObj[key] = incompletedItem.coach.id;
                  } else {
                    newObj[key] = item[key];
                  }
                }
                certificates.push(newObj);
              }
              console.log(certificates);
              incompletedItem.certificates = certificates;
            }

            if (incompletedItem.cultivates == null || incompletedItem.cultivates.length == 0) {
              console.log('cultivates没数据!');
              let cultivates = [];
              for (let i = 0; i < completedItem.cultivates.length; i++) {
                let item = completedItem.cultivates[i];
                let newObj = {};
                for(let key in item) {
                  if (key == 'id') {
                    newObj[key] = 0;
                  } else if (key == 'coachId') {
                    newObj[key] = incompletedItem.coach.id;
                  } else {
                    newObj[key] = item[key];
                  }
                }
                cultivates.push(newObj);
              }
              incompletedItem.cultivates = cultivates;
            }

            if (incompletedItem.resumes == null || incompletedItem.resumes.length == 0) {
              console.log('resumes没数据!');
              let resumes = [];
              for (let i = 0; i < completedItem.resumes.length; i++) {
                let item = completedItem.resumes[i];
                let newObj = {};
                for(let key in item) {
                  if (key == 'id') {
                    newObj[key] = 0;
                  } else if (key == 'coachId') {
                    newObj[key] = incompletedItem.coach.id;
                  } else {
                    newObj[key] = item[key];
                  }
                }
                resumes.push(newObj);
              }
              incompletedItem.resumes = resumes;
            }
          } else {
            this.$confirm("数据异常");
            return;
          }
          this.coachData = incompletedItem;
        }
        let coachData = this.coachData;
        if (coachData == null) {
          return;
        }

        let coach = coachData.coach;
        if (coach == null) {
          return;
        }
        let status = coach.status;
        let auditStatus = coach.auditStatus;
        if (auditStatus == 1) { // 开始编辑，未开始
          if (status < 5) {
            this.stepIndex = 0;
          }
          else if (status == 5) {
            this.stepIndex = 1;
          }
          else if (status == 6) {
            this.stepIndex = 2;
            //增加定时器
            this.addUpdateDataTimer();

          } else if (status == 7) { // 成功!
             this.stepIndex = 2;
             this.successed = true;
          } else if (status == 8) {
            // console.log('驳回了------');
            this.stepIndex = 2;
          }
        } else {
          this.stepIndex = 0;
        }
      },

    },
  }

</script>

<style scoped>
  #coach_certification_outer {
    margin-top: 30px;
    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: 30px;
    position: relative;
  }

  #coach_cert_top_steps /deep/ .el-step__title {
    font-size: 1rem;
    line-height: 1.5rem;
    margin-top: 15px;
  }

  #coach_cert_top_steps /deep/ .el-step__head.is-success {
    color: #666;
    border-color: #666;
  }

  #coach_cert_top_steps /deep/ .el-step__title.is-success {
    color: #666;
    font-weight: bold;
  }

  #coach_cert_top_steps /deep/ .el-step__head.is-process {
    color: #fc1a34;
    border-color: #fc1a34;
  }

  #coach_cert_top_steps /deep/ .el-step__title.is-process {
    color: #fc1a34;
  }

  #coach_cert_top_steps /deep/ .el-step__line {
    background-color: transparent;
    border-color: transparent;
  }

</style>



// WEBPACK FOOTER //
// src/components/personal/coachApplications/CoachCertification.vue